import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-template',
  templateUrl: './error-template.component.html',
  styleUrls: ['./error-template.component.scss'],
})
export class ErrorTemplateComponent implements OnInit {
  @Input() type: 'error' | 'empty' | 'empty_buildings' | 'emptyCategory' | 'loading' = 'error';
  @Input() bodyMessage: string = '';
  @Input() title: string = '';
  @Input() imageSrc?: string | null;
  @Input() imageAlt?: string;

  constructor() {}

  ngOnInit(): void {}
}
